import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Icon, IconButton, Menu } from '@emburse/embark-core';
import { Portal } from '@mui/material';
import { MoreVertIcon } from '@emburse/embark-icons';
function IconMenu({ children, anchorHorizontalPosition, anchorVerticalPosition, closeMenuOnClick, disabled, edge, icon, iconSize, onOpen, onClose, title }) {
    const [menuAnchor, setMenuAnchor] = useState(null);
    const [showMenu, setShowMenu] = useState(false);
    return (_jsxs(_Fragment, { children: [_jsx(IconButton, { disabled: disabled, edge: edge, size: iconSize, title: title, onClick: (event) => {
                    setMenuAnchor(event.currentTarget);
                    setShowMenu(true);
                    onOpen();
                }, children: _jsx(Icon, { iconUrl: icon }) }), _jsx(Portal, { container: document.body, children: _jsx(Menu, { anchorEl: menuAnchor, anchorHorizontalPosition: anchorHorizontalPosition, anchorVerticalPosition: anchorVerticalPosition, open: showMenu, onClose: () => {
                        setShowMenu(false);
                        if (!closeMenuOnClick) {
                            onClose();
                        }
                    }, onClick: () => {
                        if (closeMenuOnClick) {
                            setShowMenu(false);
                            onClose();
                        }
                    }, children: children }) })] }));
}
IconMenu.defaultProps = {
    anchorHorizontalPosition: 'center',
    anchorVerticalPosition: 'bottom',
    closeMenuOnClick: true,
    disabled: false,
    edge: false,
    icon: MoreVertIcon,
    iconSize: 'medium',
    onOpen: () => { },
    onClose: () => { }
};
export default IconMenu;
